import { render, staticRenderFns } from "./ChangeChannel.vue?vue&type=template&id=6379af05&scoped=true"
import script from "./ChangeChannel.vue?vue&type=script&lang=js"
export * from "./ChangeChannel.vue?vue&type=script&lang=js"
import style0 from "./ChangeChannel.vue?vue&type=style&index=0&id=6379af05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6379af05",
  null
  
)

export default component.exports